import React from 'react'

const Manual_facturacion_digifact_panama = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Facturación Electrónica - Digifact Panamá
        </h2>
        <iframe
          src="https://scribehow.com/embed/Facturacion_Electronica__Digifact_Panama__EXCDdw9aR6Wl8nJ7_PWXmw?as=scrollable"
          className="scribe-iframe-general-184"
          width="100%"
          height="3800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_facturacion_digifact_panama
